import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicMemoryHierarchy = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Memory Systems Hierarchy Characteristics"
      videos={[
        "https://www.youtube.com/embed/xRGUlypj89E",
        "https://www.youtube.com/embed/zwovvWfkuSg"
      ]}
      takeaways={[
        { text: "Direct theory question from this topic." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicMemoryHierarchy;
